import { c as _c } from "react/compiler-runtime";
import IconAndroidAndIOS from '@/components/assets/icon_andriodandios.svg';
import IconAndroid from '@/components/assets/icon_android.svg';
import IconDesktop from '@/components/assets/icon_desktop.svg';
import IconHeadset from '@/components/assets/icon_headset.svg';
import IconIOS from '@/components/assets/icon_ios.svg';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';
import { DeviceTypeWithAndroidIOS } from '@/types/configs';
type DeviceIconsProps = {
  deviceType: DeviceTypeWithAndroidIOS[];
  iconContainerClassName?: string;
  containerClassName?: string;
};
export default function DeviceIcons(t0) {
  const $ = _c(25);
  const {
    deviceType,
    containerClassName,
    iconContainerClassName
  } = t0;
  let t1;
  if ($[0] !== deviceType) {
    t1 = deviceType.includes("desktop");
    $[0] = deviceType;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isDesktop = t1;
  let t2;
  if ($[2] !== deviceType) {
    t2 = deviceType.includes("android");
    $[2] = deviceType;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const isAndroid = t2;
  let t3;
  if ($[4] !== deviceType) {
    t3 = deviceType.includes("ios");
    $[4] = deviceType;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const isIOS = t3;
  let t4;
  if ($[6] !== deviceType) {
    t4 = deviceType.includes("hmd");
    $[6] = deviceType;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const isHeadset = t4;
  let t5;
  if ($[8] !== containerClassName) {
    t5 = cn("flex items-center justify-between gap-1", containerClassName);
    $[8] = containerClassName;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== iconContainerClassName || $[11] !== isDesktop) {
    t6 = isDesktop && <Tooltip><TooltipTrigger asChild={true}><div className={iconContainerClassName}><IconDesktop className="size-4" /></div></TooltipTrigger><TooltipContent side="top" align="center" className="bg-sidebar-primary">Desktop</TooltipContent></Tooltip>;
    $[10] = iconContainerClassName;
    $[11] = isDesktop;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== iconContainerClassName || $[14] !== isAndroid || $[15] !== isIOS) {
    t7 = isAndroid && isIOS ? <Tooltip><TooltipTrigger asChild={true}><div className={iconContainerClassName}><IconAndroidAndIOS className="size-4" /></div></TooltipTrigger><TooltipContent side="top" align="center" className="bg-sidebar-primary">{"Android & iOS"}</TooltipContent></Tooltip> : isAndroid ? <Tooltip><TooltipTrigger asChild={true}><div className={iconContainerClassName}><IconAndroid className="size-4" /></div></TooltipTrigger><TooltipContent side="top" align="center" className="bg-sidebar-primary">Android</TooltipContent></Tooltip> : isIOS ? <Tooltip><TooltipTrigger asChild={true}><div className={iconContainerClassName}><IconIOS className="size-4" /></div></TooltipTrigger><TooltipContent side="top" align="center" className="bg-sidebar-primary">iOS</TooltipContent></Tooltip> : null;
    $[13] = iconContainerClassName;
    $[14] = isAndroid;
    $[15] = isIOS;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== iconContainerClassName || $[18] !== isHeadset) {
    t8 = isHeadset && <Tooltip><TooltipTrigger asChild={true}><div className={iconContainerClassName}><IconHeadset className="size-4" /></div></TooltipTrigger><TooltipContent side="top" align="center" className="bg-sidebar-primary">VR Headset</TooltipContent></Tooltip>;
    $[17] = iconContainerClassName;
    $[18] = isHeadset;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t5 || $[21] !== t6 || $[22] !== t7 || $[23] !== t8) {
    t9 = <div className={t5}>{t6}{t7}{t8}</div>;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  return t9;
}